import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { CommonModule } from '@angular/common';
import { NzModalService, NzModalModule, NzModalRef } from 'ng-zorro-antd/modal';
import { TipsideModalComponent } from '../../modals/tipside-modal/tipside-modal.component';
import { FormControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DataService } from '../../../services/data.service';
import { MeasurementDTO, MedicalDataDTO } from '../../../classes/api-dto';
import { HttpService } from '../../../services/http.service';
import { UserAccountDTO } from '../../../classes/user-account.dto';
import { StorageService } from '../../../services/storage.service';

@Component({
  selector: 'app-tipside',
  standalone: true,
  imports: [NzIconModule, NzBadgeModule, CommonModule, NzModalModule, TranslateModule],
  templateUrl: './tipside.component.html',
  styleUrl: './tipside.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TipsideComponent implements OnInit {
  badgeStatus: 'success' | 'error' = 'success';
  medicalData?: MedicalDataDTO;
  radioElement: string[] = ['success', 'error'];
  @Input() styleType: 'compact' | 'extended' = 'extended';

  constructor(
    private modal: NzModalService,
    private dataService: DataService,
    private http: HttpService,
    private storage: StorageService
  ) {}

  ngOnInit(): void {
    this.dataService.getMedicalData().subscribe((medicalData) => {
      if (medicalData) {
        this.medicalData = medicalData;
        this.badgeStatus = medicalData.lastMeasurement?.disclaimer ? 'success' : 'error';
      } else {
        this.setMedicalProfileData();
      }
    });
  }

  private getBadgeStatus(status: string): void {
    switch (status) {
      case 'success':
        this.badgeStatus = 'success';
        break;
      case 'error':
        this.badgeStatus = 'error';
        break;
      default:
        this.badgeStatus = 'success';
        break;
    }
  }

  protected openModifyModal(): void {
    const modalRef: NzModalRef<TipsideModalComponent> = this.modal.create({
      nzContent: TipsideModalComponent,
      nzClosable: true,
      nzFooter: null,
      nzData: {
        dataModal: { badgeStatus: this.badgeStatus, radioElement: this.radioElement },
      },
    });
    modalRef.afterClose.subscribe((result): void => {
      if (result instanceof FormControl && this.medicalData && this.medicalData.lastMeasurement) {
        const userData = JSON.parse(this.storage.getItem('userData')!) as UserAccountDTO;
        const individualId = userData?.individualId;
        let payload = this.medicalData.lastMeasurement;
        payload.contactId = individualId;
        payload.disclaimer = result.value === 'success' ? true : false;
        this.http.updateMedicalProfileData(payload).subscribe((medicalDataUpdated: MeasurementDTO) => {
          this.medicalData!.lastMeasurement = medicalDataUpdated;
          this.dataService.setMedicalData(this.medicalData!);
          this.getBadgeStatus(result.value);
        });
      }
    });
  }

  private setMedicalProfileData(): void {
    const individualId = JSON.parse(localStorage.getItem('userData')!).individualId;
    this.http.medicalProfileData(individualId).subscribe((medicalProfileData: MedicalDataDTO) => {
      this.medicalData = medicalProfileData;
      this.dataService.setMedicalData(medicalProfileData);
      this.badgeStatus = this.medicalData.lastMeasurement?.disclaimer ? 'success' : 'error';
    });
  }
}
